import { deleteRequest, get, post, put } from "../web.request";

export const submittedFormList = async (qry) => {
  return await get(`/formSubmitList${qry}`);
}

export const submittedFormDetail = async (id) => {
  return await get(`/submittedFormView/${id}`);
}